var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputView"},[_c('img',{staticClass:"imageStyle",attrs:{"src":"gzh.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }